<template>
  <div class="favorite-matchmaker-page">
    <div class="favorite-header">
      <button class="back-btn" @click="$router.go(-1)">
        <van-icon name="arrow-left" />
      </button>
      <div>
        <div class="top-title">收藏的红娘</div>
        <div class="top-desc">已收藏 {{ favoriteList.length }} 位红娘</div>
      </div>
    </div>

    <div class="favorite-list-wrap">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          @load="onLoad"
          finished-text="没有更多了"
        >
          <div v-if="favoriteList.length" class="matchmaker-list">
            <div
              v-for="item in favoriteList"
              :key="item.id"
              class="matchmaker-card"
              @click="goToDetail(item.id)"
            >
              <div class="card-head">
                <div class="card-avatar">
                  <img
                    :src="item.avatarLink || defaultPhoto"
                    alt=""
                    @error="handleImageError($event)"
                  />
                </div>
                <div class="card-main">
                  <div class="card-title-row">
                    <span class="card-name">{{ item.name }}</span>
                    <span class="card-badge">{{ getLevelText(item) }}</span>
                  </div>
                  <div class="card-score">积分：{{ item.points || 0 }} · 部门：{{ item.department || '未填写' }}</div>
                </div>
                <div class="card-favorite">
                  <van-icon
                    name="star"
                    class="is-favorite"
                    @click.stop="cancelFavorite(item)"
                  />
                </div>
              </div>

              <div class="card-stats">
                <div class="card-stat">
                  <van-icon name="location-o" />
                  <span>{{ getWorkAreaName(item.workArea) || '未填写' }}</span>
                </div>
                <div class="card-stat">
                  <van-icon name="passed" />
                  <span>{{ item.successesQuantity || 0 }} 对</span>
                </div>
                <div class="card-stat">
                  <van-icon name="friends-o" />
                  <span>{{ item.followUpQuantity || 0 }} 人跟进</span>
                </div>
                <div class="card-stat">
                  <van-icon name="star-o" />
                  <span>{{ item.points || 0 }} 积分</span>
                </div>
              </div>

              <div class="card-actions">
                <button class="card-btn outline" @click.stop="cancelFavorite(item)">取消收藏</button>
                <button class="card-btn primary" @click.stop="goToDetail(item.id)">查看详情</button>
              </div>
            </div>
          </div>

          <div v-else class="empty-state">
            <div class="empty-icon">⭐</div>
            <div class="empty-text">暂无收藏的红娘</div>
            <div class="empty-hint">去红娘中心挑选你喜欢的红娘吧</div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { getMatchmakerInfo } from "@/api/matchmakerInfo";
import { getFavoriteList, removeFavorite } from "@/api/matchmakerFavorite";

export default {
  data() {
    return {
      favoriteList: [],
      loading: false,
      finished: false,
      refreshing: false,
      defaultPhoto: require("../assets/defaultPhoto.png"),
      workAreaColumns: [
        { text: "W区", value: 1 },
        { text: "E区", value: 2 },
        { text: "M区", value: 3 },
        { text: "R区", value: 4 },
        { text: "东莞", value: 15 }
      ]
    };
  },
  computed: {
    baseInfo() {
      return this.$store.getters.baseInfo;
    }
  },
  methods: {
    getLevelText(item) {
      const point = item.points || 0;
      if (point >= 3000) return "👑 金牌";
      if (point >= 2000) return "💎 资深";
      return "🌟 优秀";
    },
    getWorkAreaName(value) {
      if (!value) return "";
      const item = this.workAreaColumns.find(col => col.value === value);
      return item ? item.text : "";
    },
    handleImageError(event) {
      event.target.src = this.defaultPhoto;
    },
    async loadData() {
      if (!this.baseInfo || !this.baseInfo.id) {
        this.finished = true;
        return;
      }

      this.loading = true;
      try {
        const res = await getFavoriteList(this.baseInfo.id);
        if (res.code === 20000 && res.data && res.data.length > 0) {
          const favoritePromises = res.data.map(id => getMatchmakerInfo({ id }));
          const detailResults = await Promise.all(favoritePromises);
          this.favoriteList = detailResults
            .filter(r => r.code === 20000 && r.data)
            .map(r => r.data);
        } else {
          this.favoriteList = [];
        }
        this.finished = true;
      } catch (error) {
        Toast.fail({ message: "加载失败" });
      } finally {
        this.loading = false;
        this.refreshing = false;
      }
    },
    onLoad() {
      this.loadData();
    },
    onRefresh() {
      this.finished = false;
      this.loadData();
    },
    async cancelFavorite(item) {
      try {
        const res = await removeFavorite(this.baseInfo.id, item.id);
        if (res.code === 20000) {
          this.favoriteList = this.favoriteList.filter(m => m.id !== item.id);
          Toast.success({ message: "已取消收藏" });
        }
      } catch (error) {
        Toast.fail({ message: "操作失败" });
      }
    },
    goToDetail(id) {
      this.$router.push({ path: `/excellentMatchmaker/${id}` });
    }
  },
  created() {
    this.loadData();
  }
};
</script>

<style lang="less" scoped src="../style/favoriteMatchmaker.less" />



// WEBPACK FOOTER //
// src/views/favoriteMatchmaker.vue